const normalizeRoles = roles => {
	if (Array.isArray(roles)) {
		return roles
			.filter(role => typeof role === 'string')
			.map(role => role.trim())
			.filter(Boolean)
	}

	if (typeof roles !== 'string') {
		return []
	}

	return roles
		.split(',')
		.map(role => role.trim())
		.filter(Boolean)
}

export const normalizeDeviceTypeGroups = deviceTypeGroups => {
	if (!Array.isArray(deviceTypeGroups)) {
		return []
	}

	return deviceTypeGroups
		.filter(
			group =>
				group &&
				Number.isInteger(group.id) &&
				typeof group.name === 'string' &&
				group.name.length > 0
		)
		.map(group => ({
			id: group.id,
			name: group.name,
			deviceTypes: Array.isArray(group.deviceTypes)
				? group.deviceTypes.filter(Number.isInteger)
				: [],
			tenantId: Number.isInteger(group.tenantId) ? group.tenantId : null,
		}))
}

export const createUserAccess = (roles, deviceTypeGroups) => ({
	isAdministrator: normalizeRoles(roles).includes('Administrator'),
	deviceTypeGroups: normalizeDeviceTypeGroups(deviceTypeGroups),
})

export const hasUsecase = (access, requiredGroupName) => {
	if (access?.isAdministrator) {
		return true
	}

	if (
		typeof requiredGroupName !== 'string' ||
		!Array.isArray(access?.deviceTypeGroups)
	) {
		return false
	}

	return access.deviceTypeGroups.some(group => group.name === requiredGroupName)
}

export const canShowUsecase = (
	access,
	requiredGroupName,
	isTenantAddUser = false
) => {
	if (isTenantAddUser) {
		return false
	}

	return hasUsecase(access, requiredGroupName)
}

export const hasMultipleTenants = tenantIds =>
	Array.isArray(tenantIds) && tenantIds.length > 1

export const fetchUserDeviceTypeGroups = async (Request, token, userId) => {
	if (userId === null || userId === undefined || userId === '') {
		return {
			deviceTypeGroups: [],
			error: {
				reason: 'missing_user_id',
				status: null,
			},
		}
	}

	try {
		const response = await Request(
			`/Users/${encodeURIComponent(
				String(userId)
			)}/devicetypegroups?pageSize=1000`,
			token
		)

		if (!response?.ok) {
			return {
				deviceTypeGroups: [],
				error: {
					reason: 'request_failed',
					status: response?.status ?? null,
				},
			}
		}

		if (!Array.isArray(response.data)) {
			return {
				deviceTypeGroups: [],
				error: {
					reason: 'invalid_response',
					status: response.status ?? null,
				},
			}
		}

		return {
			deviceTypeGroups: normalizeDeviceTypeGroups(response.data),
			error: null,
		}
	} catch {
		return {
			deviceTypeGroups: [],
			error: {
				reason: 'request_exception',
				status: null,
			},
		}
	}
}
